import { fetcher } from '../utils'
import { ComponentMessageLocationVO, ComponentMessageVO } from '@repo/types'

export default async (input: ComponentMessageLocationVO): Promise<ComponentMessageVO> =>
  fetcher(`/api/chats/location/send`, 'POST', input)
